"use client";

import { BUSINESS_PREFERENCES, PRIVAT_PREFERENCES } from "@/features/quote/shared/quote-config";
import { CheckRow } from "@/features/quote/ui/CheckRow";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { toggled } from "@/shared/lib/list";

export function PreferencesStep() {
  const { next, back, canAdvance, isBusiness } = useWizard();
  const [{ preferences = [] }, answer] = useStep("preferences");

  return (
    <section>
      <StepHeading
        title={isBusiness ? "Særlige krav?" : "Særlige ønsker?"}
        body="Valgfrit. Marker det der er relevant - det hjælper os med at finde det rigtige firma."
      />
      <CheckRow
        options={isBusiness ? BUSINESS_PREFERENCES : PRIVAT_PREFERENCES}
        values={preferences}
        onToggle={(v) => answer({ preferences: toggled(preferences, v) })}
      />
      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}
